import { Box, Skeleton, Typography } from "@mui/material";
import { colors } from "../../theme/palette";
import { useProfileData } from "../../hooks/useProfileData";

import { useTranslation } from "react-i18next";
import GoPlay from "./GoPlay";
import GoStar from "./GoStar";
import QuickActions from "./QuickActions";

const Explore = () => {
  const { t } = useTranslation();

  const { data: userData, isLoading: isUserDataLoading } = useProfileData();
  const fullName = userData.fullName;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        gap: "16px",
        boxSizing: "border-box",
        flexBasis: "77%",
        minWidth: "77%",
        position: "relative",
        "& > *": {
          boxSizing: "border-box",
        },
      }}
    >
      <Typography
        variant="h1ExtraBold"
        sx={{
          color: colors.Black100,
          marginBottom: "6px",
          display: "flex",
          alignItems: "center",
          columnGap: "8px",
        }}
      >
        {t("pages.dashboard.hi")} 👋
        {isUserDataLoading ? <Skeleton variant="rounded" height="36px" width="120px" animation="wave" /> : fullName}
      </Typography>
      <Typography
        variant="body16Regular"
        sx={{
          color: colors.Black100,
          marginBottom: "12px",
        }}
      >
        {t("pages.dashboard.howCanGoalngoHelpYouToday")}
      </Typography>
      <QuickActions />
      <GoPlay />
      <GoStar />
    </Box>
  );
};

export default Explore;
